

































































































































































import {
  computed, defineComponent, PropType, ref,
} from 'vue';
import { App } from '@/types';
import AboutText from '@/components/AboutText.vue';
import oauthClient from '@/oauth';

export default defineComponent({
  components: { AboutText },
  props: {
    apps: {
      type: Object as PropType<{ network_visualizations: App[]; table_visualizations: App[] }>,
      required: true,
    },
  },

  setup(props) {
    const dialog = ref(false);

    const multiMatrixURL = computed(() => `${props.apps.network_visualizations.filter((d) => d.name === 'MultiMatrix')[0].url}`);
    const multiLinkURL = computed(() => `${props.apps.network_visualizations.filter((d) => d.name === 'MultiLink')[0].url}`);
    const samples = computed(() => [
      {
        title: 'Paul Revere - MultiLink',
        // eslint-disable-next-line global-require
        image: require('../assets/placard/boston.jpg'),
        text: 'Explore the Paul Revere dataset using an interactive and beautiful node-link diagram. Discover the figures coordinating a pivotal event in history!',
        href: `${multiLinkURL.value}/?workspace=boston&network=boston`,
      },
      {
        title: 'Les Miserables - MultiMatrix',
        // eslint-disable-next-line global-require
        image: require('../assets/placard/miserables.jpg'),
        text: 'Explore the Les Miserables dataset using an interactive adjacency matrix. See the factions and relationships for yourself!',
        href: `${multiMatrixURL.value}/?workspace=miserables&network=miserables`,
      },
      {
        title: 'Les Miserables - MultiLink',
        // eslint-disable-next-line global-require
        image: require('../assets/placard/miserables2.jpg'),
        text: 'The characters of Les Miserables, laid out in a colorful and interactive node-link diagram.',
        href: `${multiLinkURL.value}/?workspace=miserables&network=miserables`,
      },
      {
        title: 'Paul Revere - MultiMatrix',
        // eslint-disable-next-line global-require
        image: require('../assets/placard/boston2.jpg'),
        text: 'See the relationships between Paul Revere and his contemporaries through an adjacency matrix layout.',
        href: `${multiMatrixURL.value}/?workspace=boston&network=boston`,
      },
    ]);

    function login(): void {
      oauthClient.redirectToLogin();
    }

    return {
      dialog,
      samples,
      login,
    };
  },
});
